<script>
    import classnames from 'clsx';
    import Tabs from 'flowbite/lib/esm/components/tabs/index';

    import I18n from '@js/modules/translations';
    import * as Utils from '@js/modules/utils';

    import {fetchUserRecents} from '@js/actions/userActions';
    import {fetchRides} from '@js/actions/rideActions';

    import StorageService from '@js/modules/storage';

    import RideCard from '@js/components/ride/RideCard.svelte';

    const {
        class: className,
        // titleClass,
        separator = false
    } = $props();

    let isTabMounted = $state(false);
    let tabs = $state([]);

    let ridesData = $state({});

    const _mountTabs = () => {
        const tabsElement = document.getElementById('home-recents');
        if (!tabsElement) {
            return;
        }

        const tabElements = tabs
            .filter((tab) => !!document.getElementById(`${tab}-home-recents-tab`) && !!document.getElementById(`${tab}-home-recents-content`))
            .map((tab) => ({
                id: tab,
                triggerEl: document.getElementById(`${tab}-home-recents-tab`),
                targetEl: document.getElementById(`${tab}-home-recents-content`)
            }));

        new Tabs(tabsElement, tabElements, {
            defaultTabId: tabs[0],
            activeClasses: 'font-bold text-primary-800 bg-white hover:bg-primary-300 border border-primary-700',
            inactiveClasses: 'text-gray-500 hover:bg-primary-300'
        });

        isTabMounted = true;
    };

    const _loadUserVisitedRides = () => {
        const localVisitedRides = StorageService.getLocalData('rides-visited');
        if (Utils.isPresent(localVisitedRides)) {
            return fetchRides({
                rideIds: localVisitedRides
                    .reverse()
                    .limit(4)
            });
        } else {
            return Promise.resolve();
        }
    };

    const _loadUserRecentRides = () => {
        if (window.currentUserId) {
            return fetchUserRecents(window.currentUserId);
        } else {
            return Promise.resolve();
        }
    };

    const _loadRideData = () => {
        Promise.allSettled([
            _loadUserVisitedRides(),
            _loadUserRecentRides()
        ])
            .then((results) => {
                const newRideData = {
                    visited: [],
                    planned: [],
                    created: []
                };
                const newTabs = [];

                results.forEach((result, promiseIndex) => {
                    if (result.status === 'fulfilled' && result.value) {
                        if (promiseIndex === 0) {
                            newRideData.visited = result.value.rides;
                        } else {
                            newRideData.created = result.value.created?.rides;
                            newRideData.planned = [...(result.value.planned?.rides || []), ...(result.value.poi_planned?.rides || [])];
                        }
                    }
                });

                if (newRideData.visited?.length) {
                    newTabs.push('visited');
                }
                if (newRideData.created?.length) {
                    newTabs.push('created');
                }
                if (newRideData.planned?.length) {
                    newTabs.push('planned');
                }

                ridesData = newRideData;
                tabs = newTabs;
            });
    };

    $effect(() => {
        if (!isTabMounted && tabs.length) {
            _mountTabs();
        }
    });

    _loadRideData();
</script>

{#if tabs.length > 0}
    <div class={className}>
        <ul id="home-recents"
            class="flex items-center justify-center flex-wrap gap-3 md:gap-0 mt-20 text-sm font-medium text-center text-gray-500 dark:text-gray-400"
            role="tablist">
            {#each tabs as tab (tab)}
                <li class="me-2"
                    role="presentation">
                    <button id={`${tab}-home-recents-tab`}
                            class="ml-1 md:ml-4 px-3 py-2 font-medium text-sm rounded-lg focus:outline-hidden focus:ring-2 focus:ring-primary-300"
                            type="button"
                            role="tab"
                            rel="nofollow, noindex"
                            aria-controls={tab}
                            aria-selected="false">
                        {I18n.t(`js.views.home.recents.${tab}`)}
                    </button>
                </li>
            {/each}
        </ul>

        <div id="home-recents-tab-content">
            {#each Object.entries(ridesData) as [dataName, dataRides], i (dataName)}
                <div class={classnames({hidden: i !== 0})}
                     id={`${dataName}-home-recents-content`}
                     role="tabpanel"
                     aria-labelledby={`${dataName}-home-recents-tab`}>
                    <div class="row">
                        {#each dataRides as ride (ride.id)}
                            <div class="col s12 m6 l4">
                                <RideCard ride={ride}/>
                            </div>
                        {/each}
                    </div>
                </div>
            {/each}
        </div>

        {#if separator}
            <hr class="border-b-1 border-gray-200 my-8"/>
        {/if}
    </div>
{/if}
